import { COMPANY_NAME, COMPANY_URL } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { PiccoloIcon } from '../../../components/generic/PiccoloIcon';

export const AuthCard = (props: React.PropsWithChildren) => {
  return (
    <ChakraV3.Container maxW='xl'>
      <ChakraV3.Stack w='full' align='center' gap={4} p={0}>
        <a href={COMPANY_URL} target='_blank' rel='noreferrer'>
          <ChakraV3.HStack>
            <PiccoloIcon color='white' boxSize='6' />
            <ChakraV3.Text color='white' fontWeight='bold' fontSize='xl'>
              {COMPANY_NAME}
            </ChakraV3.Text>
          </ChakraV3.HStack>
        </a>

        <ChakraV3.Stack
          w='full'
          bg='white'
          layerStyle='bordered'
          px={6}
          py={8}
          gap={6}
          rounded='xl'
        >
          {props.children}
        </ChakraV3.Stack>
      </ChakraV3.Stack>
    </ChakraV3.Container>
  );
};
